import React from "react";
import { AdminRegionPlatformFeesQuery } from "@apollo/ops";
import { LeftAlignedTerm } from "@components/ui/DescriptionList";
import { Input } from "@components/ui/Input";
import { toDollars, toCents } from "@utilities/currency";

export type AdminPlatformFeeRowData = {
  platformFeeId?: number | null;
  amount: number;
  packageTypeId: number;
};

export const AdminPlatformFeesRows: React.FC<{
  results: AdminRegionPlatformFeesQuery;
  onBlur: (data: AdminPlatformFeeRowData) => void;
}> = ({ results, onBlur }) => {
  return (
    <>
      {results.regionPlatformFees.map((regionPlatformFee) => {
        const { packageType, platformFee } = regionPlatformFee;

        return (
          <LeftAlignedTerm
            term={packageType.displayName}
            definition={
              <Input
                key={packageType.id}
                type="number"
                inlineLead="$"
                step={0.01}
                defaultValue={toDollars(platformFee?.amount || 0)}
                onBlur={(e) =>
                  onBlur({
                    platformFeeId: platformFee?.id,
                    amount: toCents(e.target.value),
                    packageTypeId: packageType.id,
                  })
                }
              />
            }
            key={packageType.id}
          />
        );
      })}
    </>
  );
};
